// CSS Modules - component class name prefix: ListTeaser__

<template>
  <div :class="[{ ListTeaser__linked: result.link }, $style.container]">
    <a
      v-if="result.link && !result.isVideo"
      :set="(isPdf = linkIsPDF(result.link))"
      :class="$style.teaserLink"
      :href="result.link"
      :target="isPdf ? '_blank' : result.target ? result.target : '_self'"
      aria-label="goto detail"
      @click="
        wtParams &&
          wtTrack(
            {
              cat: wtParams.doctype
            },
            mergeWtParams(wtParams, {
              ...result.wtParams,
              filename: result.link,
              ...(isPdf
                ? {
                    type: 'PDF'
                  }
                : {})
            })
          )
      "
    ></a>
    <div
      v-if="result.image"
      :class="[$style.mediaLink, { ListTeaser__videoLink: result.isVideo }]"
    >
      <i v-if="result.isVideo" class="fab fa-youtube"></i>
      <img :src="result.image" :alt="result.text" />
    </div>
    <div :class="$style.caption">
      <div v-if="result.subHeading" :class="$style.headingRow">
        <div :class="$style.subHeading">
          {{ result.subHeading }}
        </div>
        <img
          v-if="result.flag"
          :class="$style.flag"
          :src="result.flag"
          alt=""
        />
      </div>
      <div v-if="result.country_name" :class="$style.subHeading">
        {{ result.country_name }}
      </div>
      <h5 v-if="result.title" :class="$style.title">{{ result.title }}</h5>
      <div
        v-if="
          result.company &&
            !result.phone &&
            !result.fax &&
            !result.website &&
            !result.email
        "
        :class="$style.text"
      >
        {{ result.company }}
      </div>
      <div
        v-if="
          result.company &&
            (result.phone || result.fax || result.website || result.email)
        "
        :class="$style.headingRow"
      >
        <h5 :class="$style.title">
          {{ result.company }}
        </h5>
        <img
          v-if="!result.subHeading && result.flag"
          :class="$style.flag"
          :src="result.flag"
          alt=""
          width="16"
          height="14"
        />
      </div>
      <div v-if="result.address" :class="$style.address">
        <span
          v-html="result.address.replace(/(?:\r\n|\r|\n)/g, '<br />')"
        ></span
        ><br />
        {{ result.country }}
      </div>
      <div v-if="result.text" :class="$style.text">{{ result.text }}</div>
      <div
        v-if="result.phone || result.fax || result.website || result.email"
        :class="$style.linkBlock"
      >
        <a v-if="result.phone" :href="`tel:${result.phone}`">
          <i class="fas fa-phone-alt"></i>
          {{ result.phone }}
        </a>
        <a v-if="result.fax">
          <i class="fas fa-fax"></i>
          {{ result.fax }}
        </a>
        <a v-if="result.email" :href="`mailto:${result.email}`">
          <i class="fas fa-envelope"></i>
          {{ result.email }}
        </a>
        <a v-if="result.website" :href="result.website" target="_blank">
          <i class="fas fa-globe-americas"></i>
          {{ result.website }}
        </a>
      </div>
      <div v-if="result.files" :class="$style.downloads">
        <a
          :key="index"
          v-for="(file, index) in result.files"
          :href="file.url"
          target="_blank"
          @click="
            wtParams &&
              wtTrack(
                { cat: wtParams.doctype },
                mergeWtParams(
                  wtParams,
                  {
                    ...result.wtParams,
                    filename: file.url,
                    type: file.name.replace(/^JPG|JPEG|GIF|PNG$/, 'Image')
                  },
                  {}
                )
              )
          "
        >
          <i class="fas fa-file-pdf" v-if="file.name === 'PDF'"></i>
          <i
            class="fas fa-file-word"
            v-else-if="file.name === 'DOC' || file.name === 'DOCX'"
          ></i>
          <i
            class="fas fa-file-image"
            v-else-if="
              file.name === 'JPG' ||
                file.name === 'JPEG' ||
                file.name === 'GIF' ||
                file.name === 'PNG'
            "
          ></i>
          <i v-else class="fas fa-file"></i>
          {{ file.name }}
        </a>
      </div>
    </div>
    <a
      v-if="result.link && result.isVideo"
      :class="$style.teaserLink"
      @click="
        isModalOpen = true;
        result.wtParams &&
          wtTrack(
            { cat: wtParams.doctype },
            mergeWtParams(
              wtParams,
              {
                ...result.wtParams,
                filename: result.link
              },
              {}
            )
          );
      "
    >
    </a>
    <Modal
      v-if="result.isVideo"
      :isModalOpen="isModalOpen"
      :isVideo="result.isVideo"
      @closeModal="isModalOpen = false"
    >
      <iframe
        :src="result.link"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </Modal>
  </div>
</template>

<script>
import Modal from "../Modal/Modal";
import { mergeSwitchWtParams } from "../../utils/tracking";

export default {
  name: "ListTeaser",
  components: {
    Modal
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    wtParams: Object
  },
  methods: {
    mergeWtParams(globalWtParams, itemWtParams, itemParams) {
      return mergeSwitchWtParams(globalWtParams, itemWtParams, itemParams);
    },
    linkIsPDF(link) {
      return link && link.split("?")[0].match(/\.pdf$/g);
    }
  },
  data() {
    return {
      isModalOpen: false,
      wtTrack: window.wtTrack
    };
  }
};
</script>

<style module lang="scss">
@import "./ListTeaser.scss";
</style>
